module.exports = __webpack_public_path__ + "static/media/supportIcon.414f0a31.svg";